/*!
 * Copyright (c) HoaDev and contributors. All rights reserved.
 * More licensed under license file.
 * Created by HoaDev, 10/06/2022
 */

import { Typography } from 'antd'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import { PROJECT_TASK_PREFIX_URL } from '../modules/project/modules/project-task/constants/config.project-task'
import { TASK_FILE_CATEGORY_PREFIX_URL } from '../modules/task-file-category/constants/config.task-file-category'
import { PROJECT_TRASH_PREFIX_URL } from '../modules/project/modules/project-trash/constants/config.trash'
import {
  PROJECT_DEPARTMENT_PREFIX_URL,
  PROJECT_GENERAL_PREFIX_URL,
  PROJECT_MY_TASKS_PREFIX_URL,
  PROJECT_TEMPLATE_PREFIX_URL,
} from '../modules/project/constants/config.project'
import { QUAN_LY_GIAO_VIEC_PREFIX_URL } from './config.quan-ly-giao-viec'
import { ADMIN_GIAO_VIEC_PREFIX_URL } from '../modules/admin-giao-viec/constants/config.admin-giao-viec'
import { TASK_TAG_PREFIX_URL } from '../modules/task-tag/constants/config.task-tag'
import {
  isMenuDividerType,
  isMenuItemType,
} from '../../e-office-layout/components/dynamic-menu/helper/custom-menu-item-type-guard'
import { PROJECT_MEMBER_PREFIX_URL } from '../modules/project/modules/project-member/constants/config.project-member'
import { CUSTOM_FIELD_PREFIX_URL } from '../modules/custom-field/constants/config.custom-field'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import { CREATE_NO_DEPT_PROJECT_LIST_ROLE_PREFIX_URL } from '../modules/create-no-dept-project-list-role/constants/config.create-no-dept-project-list-role'
import { CREATE_DEPT_PROJECT_PERMISSION_PREFIX_URL } from '../modules/create-dept-project-permission/constants/config.create-dept-project-permission'

export const PROJECT_DETAIL_URL_PLACEHOLDER = 'project-detail-placeholder'

type Children = CustomMenuItemType<'item'> | CustomMenuItemType<'divider'>
/** Chỉ được 1 cấp children */
export type DetailMenuItemType =
  | Children
  | (Omit<CustomMenuItemType<'submenu'>, 'children'> & { children: Children[] })
  | (Omit<CustomMenuItemType<'group'>, 'children'> & { children: Children[] })

export const LIST_MENU_LIST_PROJECT_CONFIG: CustomMenuItemType<'group'> = {
  key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}/config`,
  label: 'Cấu hình',
  type: 'group',
  children: [
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${ADMIN_GIAO_VIEC_PREFIX_URL}`,
      label: 'Admin giao việc',
      title: 'Admin giao việc',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_TEMPLATE_PREFIX_URL}`,
      label: 'Dự án mẫu',
      title: 'Dự án mẫu',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${TASK_FILE_CATEGORY_PREFIX_URL}`,
      label: 'Danh mục tệp đính kèm',
      title: 'Danh mục tệp đính kèm',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${TASK_TAG_PREFIX_URL}`,
      label: 'Nhãn công việc',
      title: 'Nhãn công việc',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${CUSTOM_FIELD_PREFIX_URL}`,
      label: 'Trường tùy chỉnh',
      title: 'Trường tùy chỉnh',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${CREATE_DEPT_PROJECT_PERMISSION_PREFIX_URL}`,
      label: 'Quyền tạo dự án phòng ban',
      title: 'Quyền tạo dự án phòng ban',
    },
    {
      key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${CREATE_NO_DEPT_PROJECT_LIST_ROLE_PREFIX_URL}`,
      label: 'Quyền tạo dự án chung',
      title: 'Quyền tạo dự án chung',
    },
  ],
}

const LIST_MENU_DETAIL_PROJECT_CONFIG: DetailMenuItemType = {
  key: `${NO_NAVIGATE_KEY}${PROJECT_TASK_PREFIX_URL}/config`,
  label: 'Cấu hình',
  icon: <IconGlobalApp name="settings" />,
  children: [
    {
      key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_MEMBER_PREFIX_URL}`,
      label: 'Thành viên',
      title: 'Thành viên',
    },
    {
      key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TRASH_PREFIX_URL}`,
      label: 'Mục đã xóa',
      title: 'Mục đã xóa',
    },
  ],
}

const LIST_MENU_DETAIL_PROJECT_TASK: DetailMenuItemType[] = [
  {
    key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TASK_PREFIX_URL}/report`,
    icon: <IconGlobalApp name="chart-pie" />,
    label: 'Báo cáo',
    title: 'Báo cáo',
  },
  {
    key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TASK_PREFIX_URL}/view`,
    icon: <IconGlobalApp name="network" />,
    label: 'Quản lý',
    title: 'Quản lý',
  },
  {
    key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${NO_NAVIGATE_KEY}${PROJECT_TASK_PREFIX_URL}/my`,
    label: 'Của tôi',
    icon: <IconGlobalApp name="list-todo" />,
    children: [
      {
        key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TASK_PREFIX_URL}/assign-me`,
        label: 'Tôi được giao',
        title: 'Tôi được giao',
      },

      {
        key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TASK_PREFIX_URL}/expired`,
        label: 'Đã trễ hạn',
        title: 'Đã trễ hạn',
      },
    ],
  },
]

export const LIST_MENU_DETAIL_MY_TASKS: DetailMenuItemType[] = [
  {
    key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_MY_TASKS_PREFIX_URL}/report`,
    icon: <IconGlobalApp name="chart-pie" />,
    label: 'Báo cáo',
    title: 'Báo cáo',
  },
  {
    key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_MY_TASKS_PREFIX_URL}/list`,
    icon: <IconGlobalApp name="list-todo" />,
    label: 'Công việc',
    title: 'Công việc',
  },
]

export const generateGiaoViecListMenu = (
  children: CustomMenuItemType<'submenu'>['children']
): CustomMenuItemType<'submenu'> => ({
  key: `${NO_NAVIGATE_KEY}${PROJECT_TASK_PREFIX_URL}`,
  icon: <IconGlobalApp name="chart-area" />,
  label: (
    <Typography.Link strong ellipsis title="Giao việc">
      Giao việc
    </Typography.Link>
  ),
  children,
})

export const replaceDetailPlaceholder = (
  menuChildren: CustomMenuItemType<'submenu'>['children'],
  replaceString: string
): CustomMenuItemType<'submenu'>['children'] =>
  menuChildren.map((child) => {
    if (isMenuDividerType(child)) return child

    const key: string =
      child.key && child.key.toString().includes(PROJECT_DETAIL_URL_PLACEHOLDER)
        ? child.key
            .toString()
            .replace(PROJECT_DETAIL_URL_PLACEHOLDER, replaceString)
        : child.key?.toString() || ''

    if (isMenuItemType(child)) return { ...child, key }

    const children: CustomMenuItemType<'submenu'>['children'] =
      child.children && child.children.length >= 1
        ? replaceDetailPlaceholder(
            child.children as CustomMenuItemType<'submenu'>['children'],
            replaceString
          )
        : []

    return {
      ...child,
      key,
      children,
    }
  })

export const LIST_MENU_DETAIL_PROJECT_MEMBER = LIST_MENU_DETAIL_PROJECT_TASK

export const LIST_MENU_DETAIL_TEMPLATE_PROJECT: DetailMenuItemType[] = [
  {
    key: `${PROJECT_DETAIL_URL_PLACEHOLDER}${PROJECT_TASK_PREFIX_URL}/view`,
    icon: <IconGlobalApp name="network" />,
    label: 'Quản lý',
    title: 'Quản lý',
  },
]

export const LIST_MENU_DETAIL_PROJECT_LEADER_ADMIN = [
  ...LIST_MENU_DETAIL_PROJECT_TASK,
  LIST_MENU_DETAIL_PROJECT_CONFIG,
]

type Params = {
  generateDeps: (_baseUrl: string) => CustomMenuItemType<'item'>[]
  generateGenerals: (_baseUrl: string) => CustomMenuItemType<'item'>[]
  loadingDeps: boolean
  loadingGenerals: boolean
}

export const generateDynamicListMenuListProject = ({
  generateDeps,
  generateGenerals,
  loadingDeps,
  loadingGenerals,
}: Params): CustomMenuItemType<'item' | 'submenu'>[] => [
  {
    key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_MY_TASKS_PREFIX_URL}/list`,
    label: 'Công việc của tôi',
    title: 'Công việc của tôi',
  },
  {
    key: `${NO_NAVIGATE_KEY}${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_DEPARTMENT_PREFIX_URL}`,
    label: 'Dự án phòng ban',
    title: 'Dự án phòng ban',
    expandIcon: loadingDeps ? (
      <IconGlobalApp name="loader-circle" spin />
    ) : undefined,
    children: [
      {
        key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_DEPARTMENT_PREFIX_URL}`,
        label: 'Tất cả',
        title: 'Tất cả',
      },
      ...generateDeps(
        `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_DEPARTMENT_PREFIX_URL}`
      ),
    ],
  },
  {
    key: `${NO_NAVIGATE_KEY}${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_GENERAL_PREFIX_URL}`,
    label: 'Dự án chung',
    title: 'Dự án chung',
    expandIcon: loadingGenerals ? (
      <IconGlobalApp name="loader-circle" spin />
    ) : undefined,
    children: [
      {
        key: `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_GENERAL_PREFIX_URL}`,
        label: 'Tất cả',
        title: 'Tất cả',
      },
      ...generateGenerals(
        `${QUAN_LY_GIAO_VIEC_PREFIX_URL}${PROJECT_GENERAL_PREFIX_URL}`
      ),
    ],
  },
]
